import Vue from 'vue'
//@ts-ignore
import {format,Coordinate} from 'ol/coordinate'

Vue.filter('formatEPSG4326', function(value:Coordinate, onlyLat:boolean|null=null) {
  if (value) {                
    if(onlyLat == null) return format(value,'Lat {y} Lng {x}',4)
    if(onlyLat) return format(value,'{y}',4)
    else return format(value,'{x}',4)
  }
})